<template>
  <div class="register">
    <div class="header">
      <div class="logo">
        <img
          src="@/assets/icons/logo.jpg"
          alt="logo"
        >
      </div>
    </div>
    <div class="line" />
    <!-- <div style="font-size: 36px; margin-top: 22px;">
      <b>{{ $t('register/tip') }}</b>
    </div>
    <div style="font-size: 18px; margin-top: 17px;">
      {{ $t('register/tip2') }}
    </div> -->
    <a-form-model
      ref="ruleForm"
      class="ant-advanced-search-form"
      :model="form"
      :rules="rules"
    >
      <div class="subTitle">
        {{ $t('register/info') }}
      </div>
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-model-item
            ref="participant_type"
            prop="participant_type"
            :label="$t('register/participantType')+$t('register/participantTypeTip')"
            required
          >
            <a-radio-group v-model="form.participant_type">
              <a-radio value="1">{{ $t('register/person') }}</a-radio>
              <a-radio value="2">{{ $t('register/company') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <!-- <a-col span="12">
          <a-form-model-item
            ref="title"
            prop="title"
            :label="$t('user-productInfo-brand/title')"
          >
            <a-input v-model="form.title" />
          </a-form-model-item>
        </a-col> -->
        <a-col span="12">
          <a-form-model-item
            ref="name"
            prop="name"
            :label="form.participant_type === '2' ? $t('user-productInfo-brand/name_contact_person') : $t('user-productInfo-brand/name') "
            required
          >
            <a-input v-model="form.name" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="form"
            prop="form"
            :label="$t('register/gender')"
            required
          >
            <a-radio-group v-model="form.form">
              <a-radio value="1">{{ $t('register/male') }}</a-radio>
              <a-radio value="2">{{ $t('register/female') }}</a-radio>
              <!-- <a-radio value="3">{{ $t('register/notToSay') }}</a-radio> -->
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <!-- <a-col span="12">
          <a-form-model-item
            ref="lastname"
            prop="lastname"
            :label="$t('user-productInfo-brand/lastname')"
            required
          >
            <a-input v-model="form.lastname" />
          </a-form-model-item>
        </a-col> -->
        <!-- <a-col span="12">
          <a-form-model-item
            ref="firstname"
            prop="firstname"
            :label="$t('user-productInfo-brand/firstname')"
            required
          >
            <a-input v-model="form.firstname" />
          </a-form-model-item>
        </a-col> -->
        <a-col span="12">
          <a-form-model-item
            ref="phone"
            prop="phone"
            :label="$t('register/phone')"
            required
          >
            <a-input v-model="form.phone" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="email"
            prop="email"
            :label="$t('register/email') + $t('register/emailMark')"
            required
          >
            <a-input v-model="form.email" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="password"
            prop="password"
            :label="$t('register/password')"
            required
          >
            <a-input-password v-model="form.password" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="password_confirmation"
            prop="password_confirmation"
            :label="$t('register/rePassword')"
            required
          >
            <a-input-password v-model="form.password_confirmation" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="identity_type"
            prop="identity_type"
            :label="$t('register/identityType')"
            required
          >
            <a-select
              v-model="form.identity_type"
              show-search
            >
              <a-select-option
                value="1"
              >
                {{ $t('register/identity') }}
              </a-select-option>
              <a-select-option
                value="2"
              >
                {{ $t('register/passport') }}
              </a-select-option>
              <a-select-option
                value="3"
              >
                {{ $t('register/accessPass') }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="sfzhm"
            prop="sfzhm"
            :label="$t('register/identificationNumber') "
            required
          >
            <a-input v-model="form.sfzhm" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col span="8">
          <a-modal
            :visible="previewVisible"
            :footer="null"
            :style="'transform: scale(' + previewVisibleScale + ');top: 0;'"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
              @mousewheel="mousewheel"
            >
          </a-modal>
        </a-col> -->
        <a-col span="8">
          <a-form-model-item
            ref="company_name"
            prop="company_name"
            :label="$t('register/name')"
          >
            <a-input v-model="form.company_name" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col span="12">
          <a-form-model-item
            ref="company_ename"
            prop="company_ename"
            :label="$t('register/ename')"
          >
            <a-input v-model="form.company_ename" />
          </a-form-model-item>
        </a-col> -->
        <a-col span="8">
          <a-form-model-item
            ref="street"
            prop="street"
            :label="$t('user-productInfo-brand/address')"
            required
          >
            <a-input v-model="form.street" />
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item
            ref="position"
            prop="position"
            :label="$t('user-productInfo-brand/position')"
          >
            <a-input v-model="form.position" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col span="8">
          <a-form-model-item
            ref="cydwlb"
            prop="cydwlb"
            :label="$t('user-comphonents-step1/source_label')"
            required
          >
            <a-select
              v-model="form.cydwlb"
              :default-active-first-option="false"
              :placeholder="$t('user-comphonents-step1/source_label')"
            >
              <a-select-option
                v-for="item in channels"
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col> -->
      </a-row>
      <a-row :gutter="24">
        <a-col span="6">
          <a-form-model-item
            ref="country"
            prop="country"
            :label="$t('user-productInfo-brand/country')"
            required
          >
            <a-select
              v-model="form.country"
              show-search
            >
              <a-select-option
                v-for="i in countryFormat[$i18n.locale || 'zh']"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <!-- 省份-下拉列表 -->
        <a-col v-if="form.country === 'China' || form.country === '中国'" span="6">
          <a-form-model-item
            ref="province"
            prop="province"
            :label="$t('admin-judge420/name7')"
          >
            <a-select
              v-model="form.province"
              show-search
              :placeholder="$t('admin-judge420/name7')"
              @change="form.city = ''"
            >
              <a-select-option
                v-for="i in provinceData"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item
            ref="city"
            prop="city"
            :label="$t('user-productInfo-brand/city')"
            required
          >
            <a-input v-if="form.country !== 'China' && form.country !== '中国'" v-model="form.city" />
            <a-select
              v-if="form.country === 'China' || form.country === '中国'"
              v-model="form.city"
              show-search
              :placeholder="$t('user-productInfo-brand/city')"
              @change="form.region = ''"
            >
              <a-select-option
                v-for="i in cityData"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
            <!-- <a-select
              v-if="form.country === 'China' || form.country === '中国'"
              v-model="form.city"
              show-search
            >
              <a-select-option
                v-for="i in cityFormat[$i18n.locale || 'zh']"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select> -->
          </a-form-model-item>
        </a-col>
        <a-col v-if="(form.country === 'China' || form.country === '中国') && (form.city === 'Zhangzhou' || form.city === '漳州')" span="6">
          <a-form-model-item
            ref="region"
            prop="region"
            :label="$t('user-productInfo-brand/region')"
            required
          >
            <a-select
              v-model="form.region"
              show-search
              :placeholder="$t('user-productInfo-brand/region')"
            >
              <a-select-option
                v-for="i in zhangzhouRegionFormat[$i18n.locale || 'zh']"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item
            ref="homepage"
            prop="homepage"
            :label="$t('register/homepage')"
          >
            <a-input v-model="form.homepage" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="tip">
        {{ $t('register/tip4') }} <font color="#ed1c24" /> {{ $t('register/tip5') }}
      </div>

      <div
        class="submit"
      >
        <div class="check-box">
          <a-form-model-item
            ref="checkValue"
            prop="checkValue"
            required
          >
            <a-checkbox v-model="form.checkValue">{{ $t('register/tip6')
            }}</a-checkbox>
          </a-form-model-item>

          <a :href="`javascript: window.open('/chengnuoshu.pdf')`" style="color: #006ae1;">{{ $t('register/tip7')
          }}</a>
          <br>
        </div>
        <a-button
          html-type="button"
          type="primary"
          size="large"
          block
          @click="confirm"
        >
          {{ $t('register/register') }}
        </a-button>
      </div>
    </a-form-model>
    <Modal
      :show-modal="showModal"
      @cancel="cancel"
      @confirm="confirm"
    >
      <div class="modal_title">
        {{ $t('register-verify/choose') }}
      </div>
      <div style="margin-top: 29px;">
        <a-select
          v-model="type"
          style="width: 100%;line-height: 40px;"
        >
          <a-select-option v-if="$i18n.locale === 'zh'" value="1">
            {{ $t('register/sms') }}
          </a-select-option>
          <a-select-option value="2">
            {{ $t('register/workEmail') }}
          </a-select-option>
        </a-select>
      </div>
      <div style="margin-top: 32px;display: flex;">
        <a-input v-model="code" size="large" :placeholder="$t('register/verification')" />
        <a-button size="large" type="primary" :disabled="!!countTxt" @click="sendCode">{{ $t('register-verify/send') + countTxt }}</a-button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/views/components/Modal.vue'
import { register, mailCode, userSendCode } from '@/api/login'
// import { storeBefore } from '@/api/product'
import countryFormat from '@/utils/country.js'
import cityFormat from '@/utils/city.js'
import zhangzhouRegionFormat from '@/utils/zhangzhouRegion.js'
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'
import area_cn from '@/utils/area_cn.js' // 中文
import area_en from '@/utils/area_en.js' // 英文
import request from '@/utils/request'

const i18n = { zh, en }
const lang = getLKey()

function getBase64(files) {
  return new Promise((resolve, reject) => {
    if (!files.length) {
      const reader = new FileReader()
      reader.readAsDataURL(files)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    } else {
      // 多图片转换
      const array = []
      const length = files.length
      for (const i in files) {
        const reader = new FileReader()
        reader.readAsDataURL(files[i])
        reader.onload = function() {
          array.push(reader.result)
          if (array.length === length) {
            resolve(array)
          }
        }
        reader.onerror = error => reject(error)
      }
    }
  })
}

function emailValidate(rule, value, callback) {
  if (!value || value.trim() === '') {
    callback(new Error(i18n[lang]['admin-user-user/pemaill']))
    return
  }

  const trimmedValue = value.trim()
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  if (emailReg.test(trimmedValue)) {
    callback()
  } else {
    callback(new Error(i18n[lang]['view-components-components/mailError']))
  }
}

const password = []
function passwordValidate(rule, value, callback) {
  console.log(password)
  if (value) {
    if (value.length < 8) return callback(i18n[lang]['admin-password-password/8-bit'])
    if (value.length > 32) return callback(i18n[lang]['register/passwordlong'])
    password[rule.field === 'password' ? 0 : 1] = value
    if (password[0] && password[1] && password[0] !== password[1]) {
      callback(i18n[lang]['admin-password-password/different-passwords'])
    } else {
      callback()
    }
  } else {
    callback(i18n[lang]['admin-password-password/please-enter'])
  }
}

export default {
  name: 'Register',
  components: {
    Modal
  },
  data() {
    return {
      request: request,
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        firstname: '',
        lastname: '',
        name: '',
        participant_type: '',
        identity_type: '',
        sfzhm: '',
        form: '',
        title: '',
        position: '',
        phone: '',
        // young_pro: '',
        images: [],
        company_name: '',
        // company_ename: '',
        street: '',
        zip: '',
        city: '',
        region: '',
        country: '中国',
        homepage: '',
        address_phone: '',
        address_email: '',
        address_fax: '',
        // cydwlb: '',
        checkValue: undefined
      },
      // channels: [],
      rules: {
        company_name: [
          { required: true, message: i18n[lang]['user-address/company'], trigger: ['change', 'blur'] }
        ],
        // company_ename: [
        //   { required: true, message: i18n[lang]['user-address/ecompany'], trigger: ['change', 'blur'] }
        // ],
        street: [
          { required: true, message: i18n[lang]['user-address/paddress'], trigger: ['change', 'blur'] }
        ],
        // zip: [
        //   { required: true, message: i18n[lang]['register/pcode'], trigger: ['change', 'blur'] }
        // ],
        city: [
          { required: true, message: i18n[lang]['register/pcity'], trigger: ['change', 'blur'] }
        ],
        region: [
          { required: true, message: i18n[lang]['register/pregion'], trigger: ['change', 'blur'] }
        ],
        country: [
          { required: true, message: i18n[lang]['register/pcountry'], trigger: ['change', 'blur'] }
        ],
        // address_phone: [
        //   { required: true, message: i18n[lang]['register/pphone'], trigger: ['change', 'blur'] }
        // ],
        // address_email: [
        //   { required: true, message: i18n[lang]['register/pmailbox'], trigger: ['change', 'blur'], validateFirst: true },
        //   { validator: emailValidate, trigger: ['change', 'blur'] }
        // ],
        // homepage: [
        //   { required: true, message: i18n[lang]['register/phome'], trigger: ['change', 'blur'] }
        // ],
        // young_pro: [
        //   { required: true, message: i18n[lang]['register/select'], trigger: 'change' }
        // ],
        participant_type: [
          { required: true, message: i18n[lang]['register/select-participant-type'], trigger: ['change', 'blur'] }
        ],
        identity_type: [
          { required: true, message: i18n[lang]['register/select-identity-type'], trigger: ['change', 'blur'] }
        ],
        sfzhm: [
          { required: true, message: i18n[lang]['register/select-identification-number'], trigger: ['change', 'blur'] }
        ],
        form: [
          { required: true, message: i18n[lang]['register/select-gender'], trigger: ['change', 'blur'] }
        ],
        name: [
          { required: true, message: i18n[lang]['admin-user-user/pname'], trigger: ['change', 'blur'] }
        ],
        // lastname: [
        //   { required: true, message: i18n[lang]['admin-user-user/psurname'], trigger: ['change', 'blur'] }
        // ],
        // firstname: [
        //   { required: true, message: i18n[lang]['admin-user-user/pinputn'], trigger: ['change', 'blur'] }
        // ],
        phone: [
          { required: true, message: i18n[lang]['admin-user-user/pinputp'], trigger: ['change', 'blur'] }
        ],
        email: [
          { required: true, message: i18n[lang]['admin-user-user/pemaill'], trigger: ['change', 'blur'] },
          { validator: emailValidate, trigger: ['change', 'blur'] }
        ],
        password: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ],
        password_confirmation: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ],
        checkValue: [
          { required: true, message: i18n[lang]['admin-user-user/read_and_agree_commitment'], trigger: ['change', 'blur'] }
        ]
        // cydwlb: [
        //   { required: true, message: '请选择从业单位类别', trigger: ['change', 'blur'] }
        // ]
      },
      showModal: false,
      // 图片上传
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'image.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        // }
      ],
      previewImage: '',
      previewVisible: false,
      uploadStatus: 'done',
      type: '', // 验证类型
      code: '', // 验证码
      countTxt: '',
      countryFormat: countryFormat,
      cityFormat: cityFormat,
      zhangzhouRegionFormat: zhangzhouRegionFormat,
      previewVisibleScale: 1

    }
  },
  computed: {
    provinceData() { // 所有的省份
      return this.locale === 'en' ? area_en.provinceData : area_cn.provinceData
    },
    cityData() { // 所有的城市
      const area = this.locale === 'en' ? area_en : area_cn
      return area.cityData[this.form.province]
    }
  },
  created() {
    // 获取从业单位类别数据
    // storeBefore('1').then(res => {
    //   this.channels = res.channels || []
    // }).catch(res => {
    //   console.error(res)
    // })
  },
  methods: {
    mousewheel(e) {
      if (this.previewVisibleScale < 0.2 && e.deltaY > 0) return
      this.previewVisibleScale -= e.deltaY / 2500
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      this.previewVisibleScale = 1
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      this.fileList = fileList
      // 图片不单独上传，未配服务器地址时图片会出现红框
      for (const i in this.fileList) {
        fileList[i].status = 'success'
      }
    },
    register() {
      const that = this
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const imgsList = that.fileList.map(i => i.originFileObj)
          for (const i in imgsList) {
            if (imgsList[i].type !== 'image/jpeg' && imgsList[i].type !== 'image/png') {
              return this.$message.error({ content: i18n[lang]['register/upload-certificate'], key: 'message' })
            }
          }
          if (imgsList.length) this.form.images = await getBase64(imgsList)
          this.showModal = true
          this.type = ''
          this.code = ''
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCode() {
      if (!this.type) {
        return this.$message.warning({ content: this.$t('view-components-components/verification'), key: 'message', duration: 4 })
      }
      if (this.type === '1') {
        userSendCode({ phone: this.form.phone, type: 1 }).then(res => {
          this.$message.success({ content: this.$t('view-components-components/send'), key: 'message', duration: 4 })
          this.countDown()
        })
      }
      if (this.type === '2') {
        mailCode({ email: this.form.email, type: 1 }).then(res => {
          this.$message.success({ content: this.$t('view-components-components/send'), key: 'message', duration: 4 })
          this.countDown()
        })
      }
    },
    countDown() {
      let t = 60
      this.countTxt = '(' + t + ')'
      const timer = setInterval(() => {
        if (t !== 0) {
          this.countTxt = '(' + --t + ')'
        } else {
          this.countTxt = ''
          clearInterval(timer)
        }
      }, 1000)
    },
    cancel() {
      this.showModal = false
    },
    confirm() {
      const that = this
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.$message.loading({ content: 'loading...', key: 'message' })

          const data = JSON.parse(JSON.stringify(that.form))
          data.type = this.type
          data.code = this.code
          console.log(data)
          console.log(JSON.stringify(data))
          register(data).then(res => {
            that.showModal = false
            that.$message.success({ content: i18n[lang]['register/registration-success'], key: 'message', duration: 4 })
            that.$router.push({ path: '/login' })
          }).catch(res => {
            console.error(res)
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .register {
    margin: 0 auto;
    padding-top: 34px;
    min-width: 700px;
    max-width: 1000px;
    font-size: 18.65px;
  }

  .tools {
    float: left;
    margin-top: 15.37vh;
  }

  .logo {
    text-align: center;
  }

  .logo img{
    height: 30vh;
    width: 30vh;
  }

  .line {
    width: 100%;
    height: 2px;
    clear: both;
    padding-top: 21px;
    background: #333333;
    background-clip: content-box;
    box-sizing: content-box;
  }

  .subTitle {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
    margin-bottom: 17px;
  }

  .tip {
    color: #999;
  }

  .submit {
    margin: 54px auto;
    text-align: center;
    width: 375px;
    .check-box{
      text-align: left;
      // margin-bottom: 20px;
      display: flex;
      align-items: self-start;
      line-height: 40px;
    }
  }

  .modal_title {
    font-size: 24px;
    z-index: 20;
  }

</style>
<style>
  /* 重写上传组件 */
  .ant-upload.ant-upload-select-picture-card {
    height: auto;
    width: 100%;
    border: 0;
    background: transparent;
  }

  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0;
    vertical-align: bottom;
    text-align: left;
  }

  .wordStyleRepair {
    margin-bottom: 20px !important;
  }

  .wordStyleRepair .ant-form-explain {
    display: inline-block;
  }

  .changeLine .ant-form-item-label{
    white-space: normal;
    text-align: left;
  }
</style>
